import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { APIEndPoints } from 'src/app/configs/api-endpoints';
import { environment } from 'src/environments/environment';
// import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {
  url = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  getNotesData(body){
    return this.http.get<any>(`${this.url}${APIEndPoints.LeaderBoard.GetUserRankingList}?programActivationId=${body.programActivationId}&page=${body.page}&limit=${body.limit}`)
      .pipe(map(res => {
        return res.data;
      }
    ));
  }
}
